import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { keyHdkdEcdsa } from "./hdkdEcdsa.js";
import { keyHdkdEd25519 } from "./hdkdEd25519.js";
import { keyHdkdSr25519 } from "./hdkdSr25519.js";
var generators = {
  ecdsa: keyHdkdEcdsa,
  ed25519: keyHdkdEd25519,
  // FIXME This is Substrate-compatible, not Ethereum-compatible
  ethereum: keyHdkdEcdsa,
  sr25519: keyHdkdSr25519
};
export function keyFromPath(pair, path, type) {
  var keyHdkd = generators[type];
  var result = pair;

  var _iterator = _createForOfIteratorHelper(path),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var junction = _step.value;
      result = keyHdkd(result, junction);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}